/**
 * @packageDocumentation
 * @module f1/fn
 */

/**
 *
 * @param ignore the value does not affect the final outcome
 */
export type AlwaysValue<V> = (ignore: unknown) => V;

export interface Always {
  /**
   * Creates a function that always returns a given value
   *
   * @public
   * @function f1.always
   * @param val the value to __always__ return
   * @param ignore the value does not affect the final outcome
   * @example
   *
   * ```ts
   * 	always(true)() === true
   * 	always(true)(false) === true
   * 	always(42)(42) === 42
   * 	always(42)(4) === 42
   * ```
   */
  <V>(val: V, ignore: unknown): V;
  /**
   * {@link FnAlwaysValue}
   * @param val the value to __always__ return
   */
  <V>(val: V): AlwaysValue<V>;
}

/**
 * @see Always
 * @note we leave the `ignore` parameter out so we do not need typescript exceptions, the `ignore` is accounted for on the interface
 */
export default <V>(val: V): V => val;
